<template>
  <div>
    <el-card>
      <el-input
        v-model="coinType"
        size="mini"
        class="search"
        placeholder="输入币种搜索"
      ></el-input>
      <el-input
        v-model="pledgeId"
        size="mini"
        class="search"
        placeholder="定期宝ID"
      ></el-input>
      <el-input
        v-model="userId"
        size="mini"
        class="search"
        placeholder="用户ID"
      ></el-input>
      <el-button
        type="primary"
        icon="el-icon-search"
        @click="queryData()"
        circle
        size="mini"
      ></el-button>
      <el-table v-if="tableAble" :data="pledgeUser">
        <el-table-column label="定期宝ID" prop="pledgeId"></el-table-column>
        <el-table-column label="币种" prop="cointype"></el-table-column>
        <el-table-column label="数额" prop="amount"></el-table-column>
        <el-table-column prop="annualrate" label="年利率">
          <template slot-scope="scope">
            <span>{{ multiply(scope.row.annualrate, 100) }}%</span>
          </template>
        </el-table-column>
        <el-table-column label="天数" prop="day"></el-table-column>
        <el-table-column label="利息" prop="interest"></el-table-column>
        <el-table-column label="用户ID" prop="userId"></el-table-column>
        <el-table-column label="时间">
          <template slot-scope="scope">
            {{ scope.row.createdTime | moment }}
          </template>
        </el-table-column>
      </el-table>
      <div class="pager-wrap">
        <pagination
          :size="pager.size"
          :page="pager.page"
          :total="pledgeUserTotal"
          @pageChanged="handlPageChanged"
        >
        </pagination>
      </div>
    </el-card>
  </div>
</template>
<script>
import "../store.js";
import { mapState, mapActions } from "vuex";
import math from "common/math";
import Pagination from "components/pagination";
import { formatTable } from "../../../common/tools.js";
export default {
  name: "dataCenterPledge",
  data() {
    return {
      coinType: "",
      pledgeId: "",
      userId: "",
      pager: {
        page: 1,
        size: 10,
      },
    };
  },
  methods: {
    ...mapActions("dataCenter", ["getAllCoins", "getPledgeUser"]),
    multiply(a, b) {
      return math.multiply(a, b);
    },
    queryData() {
      let q = {
        page: this.pager.page,
        size: this.pager.size,
      };
      if (this.coinType) q.coinType = this.coinType;
      if (this.pledgeId) q.pledgeId = this.pledgeId;
      if (this.userId) q.userId = this.userId;
      this.getPledgeUser(q);
    },
    handlPageChanged(pagination) {
      this.pager.page = pagination.page;
      this.pager.size = pagination.size;
      this.queryData();
    },
  },
  computed: {
    ...mapState("dataCenter", ["allCoins", "pledgeUser", "pledgeUserTotal", "tableAble"]),
  },
  watch: {
    pledgeUser() {
      formatTable();
    },
  },
  components: {
    Pagination,
  },
  mounted() {},
};
</script>
<style scoped>
.search {
  width: 200px;
  margin: 0px 20px 20px 0px;
}
.date-search {
  margin-right: 20px;
}
.swt {
  margin-right: 20px;
}
</style>
